export type NovaQrFulfilment =
  | "dine-in"
  | "takeaway";

export type NovaQrOrderLine = {
  lineId: string;
  itemId: string;
  itemName: string;

  variantId: string | null;
  variantLabel: string | null;

  unitPrice: number;
  quantity: number;
  lineTotal: number;
};

export type NovaQrOrderDraft = {
  version: 1;

  source: "qr-menu";

  channel: "web";

  tableNumber: string | null;

  fulfilment: NovaQrFulfilment;

  guest: {
    name: string | null;
    phone: string | null;
  };

  currency: "KES";

  lines: NovaQrOrderLine[];

  totals: {
    subtotal: number;
    total: number;
  };

  createdAt: string;
};

type BuildNovaQrOrderDraftInput = {
  tableNumber: string | null;

  fulfilment: NovaQrFulfilment;

  guestName?: string;
  guestPhone?: string;

  lines: NovaQrOrderLine[];
};

function cleanOptionalText(
  value?: string,
) {
  const cleaned =
    value?.trim() ?? "";

  return cleaned || null;
}

export function buildNovaQrOrderDraft({
  tableNumber,
  fulfilment,
  guestName,
  guestPhone,
  lines,
}: BuildNovaQrOrderDraftInput): NovaQrOrderDraft {
  const subtotal =
    lines.reduce(
      (sum, line) =>
        sum + line.lineTotal,
      0,
    );

  return {
    version: 1,

    source: "qr-menu",

    channel: "web",

    tableNumber,

    fulfilment,

    guest: {
      name:
        cleanOptionalText(
          guestName,
        ),
      phone:
        cleanOptionalText(
          guestPhone,
        ),
    },

    currency: "KES",

    lines,

    totals: {
      subtotal,
      total: subtotal,
    },

    createdAt:
      new Date().toISOString(),
  };
}
